import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";

// ecommerce saga
import businessSettingsSaga from "./business-settings/saga";

// products saga
import productsSaga from "./products/saga";

// product categories saga
import productCategoriesSaga from "./product-categories/saga";

// delivery men saga
import deliveryMenSaga from "./delivery-men/saga";

// coupons saga
import couponsSaga from "./coupons/saga";

// discount types saga
import discountTypesSaga from "./discount-types/saga";

// orders saga
import ordersSaga from "./orders/saga";

// disputes saga
import disputesSaga from "./disputes/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),

    fork(businessSettingsSaga),
    fork(productsSaga),
    fork(productCategoriesSaga),
    fork(deliveryMenSaga),
    fork(couponsSaga),
    fork(discountTypesSaga),
    fork(ordersSaga),
    fork(disputesSaga),
  ]);
}
